// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"1960d2c9","546":"43751755","585":"71bee9c8","616":"c868d8db","821":"881d3e39"}[chunkId] + ".chunk.js";
};